var map = {
	"./camp-bbq.svg": "97be",
	"./camping.svg": "fc3e",
	"./close.svg": "0ebf",
	"./concrete.svg": "dcea",
	"./cross-red.svg": "83bf",
	"./cross.svg": "2bc0",
	"./edit.svg": "7914",
	"./grassed.svg": "58cb",
	"./icon_link-indicator.svg": "bc7f",
	"./info.svg": "9238",
	"./kitchen.svg": "1f32",
	"./kitchenette.svg": "ad3a",
	"./magnify.svg": "d41a",
	"./remove.svg": "efa0",
	"./sleeps.svg": "8ff8",
	"./tick-green.svg": "e18e",
	"./tick.svg": "c594",
	"./waterview.svg": "77e1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "07e6";